import TextareaCounter from '../TextareaCounter';

export const DIRECTIVE_VALUE = 'textarea-counter';

function transformPropertyName(propertyName) {
  const mapping = {
    maxlength: 'maxLength',
    class: 'className',
  };

  return mapping[propertyName] || propertyName;
}

function isPropertyValid(property) {
  return property.name !== 'data-component' && property.nodeValue;
}

function combineProperties(allProperties, property) {
  return {
    ...allProperties,
    [transformPropertyName(property.name)]: property.nodeValue,
  };
}

function TextareaCounterFromDom({ textarea = null }) {
  const props = [...textarea.attributes].filter(isPropertyValid).reduce(combineProperties, {});
  return <TextareaCounter {...props}>{textarea.value}</TextareaCounter>;
}

export default TextareaCounterFromDom;
